import type { FC, ReactNode } from 'react'

import { delay } from '@/lib/ui'
import { Plate } from '@/components/generals/plate'
import { SplitWords } from '@/components/generals/split-words'

export const ContactClosing: FC = (): ReactNode => {
    return (
        <>
            <section id='print-room' className='ed-wrap pt-[clamp(62px,9vh,120px)]'>
                <div className='grid gap-y-10 md:grid-cols-12 md:items-end md:gap-x-[clamp(20px,3vw,48px)]'>
                    <div className='md:col-span-8'>
                        <Plate
                            className='aspect-[16/10]'
                            src='/images/contact/studio.jpg'
                            alt='Low sun through slatted blinds falling across an empty studio wall'
                            sizes='(max-width: 767px) 100vw, 66vw'
                            parallax='64'
                        />
                    </div>

                    <div className='md:col-span-3 md:col-start-10 md:pb-[clamp(10px,3vh,44px)]'>
                        <div className='ed-mono text-faint' data-reveal='up'>
                            The print room
                        </div>

                        <p className='ed-body mt-4' data-reveal='up' style={delay(0.06)}>
                            Vaults Yard, Bermondsey. Visits by appointment, and there is usually something on
                            the wall that has not been published yet.
                        </p>
                    </div>
                </div>
            </section>

            <section className='relative mt-[clamp(62px,9vh,120px)]'>
                <Plate
                    className='h-[clamp(360px,70vh,720px)] w-full'
                    src='/images/contact/closing.png'
                    alt='Aerial view of a shoreline where turquoise water meets pale sand and dark rock'
                    sizes='100vw'
                    parallax='90'
                />

                <span className='pointer-events-none absolute inset-0 bg-gradient-to-t from-[rgba(5,5,10,0.8)] via-[rgba(5,5,10,0.2)] to-transparent' />

                <div className='pointer-events-none absolute inset-x-0 bottom-0'>
                    <div className='ed-wrap pb-[clamp(28px,6vh,76px)]'>
                        <div className='ed-h2 on-photo max-w-[15ch]' data-reveal='words'>
                            <SplitWords text='The next one is already out there' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
